import React from 'react';
import custom from './StatusBadge.scss';

const StatusBadge = ({ children }) => (
  <span className={`${custom.StatusBadge__span} ${custom.StatusBadge__span__label}`}>{children}</span>
);

StatusBadge.defaultProps = {
  children: null,
  className: undefined,
  type: 'default',
};

export default StatusBadge;
